import dayjs from "apps/visits/packages/shared/libs/dayjs";
import { DATE_FORMAT, DATE_OF_BIRTH_API_FORMAT } from "../config/date-time";

export const formatDateOfBirthForApi = (dateOfBirth: string | undefined) => {
  return dateOfBirth ? dayjs(dateOfBirth, DATE_FORMAT).format(DATE_OF_BIRTH_API_FORMAT) : undefined;
};
